import { render, staticRenderFns } from "./SaleTagForm.vue?vue&type=template&id=57cf5590"
import script from "./SaleTagForm.vue?vue&type=script&lang=js"
export * from "./SaleTagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports